/* src/app/shared/components/ngx-responsive-table/ngx-responsive-table.component.scss */
.ngx-responsive-table {
  width: 100%;
  overflow: auto;
  border: solid thin #f4f4f4;
}
.ngx-responsive-table ::ng-deep table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9375em;
  background-color: white;
}
.ngx-responsive-table ::ng-deep table thead tr th,
.ngx-responsive-table ::ng-deep table tbody tr td {
  white-space: nowrap;
  line-height: 1.6;
  transition: height 0.3s ease, padding 0.3s ease;
}
.ngx-responsive-table ::ng-deep table thead {
  background-color: #d9d9d6;
}
.ngx-responsive-table ::ng-deep table thead tr th {
  font-size: 1em;
  font-weight: 700;
  color: #595555;
  height: 3.3333333333em;
  padding: 0.5333333333em 0.6666666667em 0.5333333333em 0.6666666667em;
}
.ngx-responsive-table ::ng-deep table tbody {
  width: 100%;
}
.ngx-responsive-table ::ng-deep table tbody tr {
  width: 100%;
}
.ngx-responsive-table ::ng-deep table tbody tr:nth-child(even) {
  background-color: #f4f4f4;
}
.ngx-responsive-table ::ng-deep table tbody tr ngx-toggle-switch {
  display: none;
}
.ngx-responsive-table ::ng-deep table tbody tr td {
  font-size: 0.8666666667em;
  color: #595555;
  height: 3.8461538462em;
  padding: 0.6153846154em 0.7692307692em 0.6153846154em 0.7692307692em;
}
.ngx-responsive-table ::ng-deep table tbody tr td .actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.ngx-responsive-table ::ng-deep table tbody tr td .actions .action,
.ngx-responsive-table ::ng-deep table tbody tr td .actions button {
  line-height: 2.35em;
  height: 1.875rem;
  margin: 0 0.5231em;
}
.ngx-responsive-table ::ng-deep table tbody tr td .actions .action:first-of-type,
.ngx-responsive-table ::ng-deep table tbody tr td .actions button:first-of-type {
  margin-left: 0;
}
ngx-table-control-panel {
  margin-bottom: 0.5em;
}
:host {
  width: 100%;
}
/*# sourceMappingURL=ngx-responsive-table.component.css.map */
